module.exports = __webpack_public_path__ + "static/media/sg4cr128.3e29d1ac.png";